// EXPIRATION_DURATION defines how close to expiry a token is considered expired (5 minutes)
const EXPIRATION_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// Checks if a JWT token is expired or about to expire within EXPIRATION_DURATION
// token: decoded JWT object with 'exp' property (expiration time in seconds)
// Returns true if token is expired or will expire soon, false otherwise
export const isTokenExpired = (token: any): boolean => {
  const expirationDate = token?.exp * 1000;
  return expirationDate
    ? expirationDate - new Date().getTime() < EXPIRATION_DURATION
    : false;
};
